export default function Logo({
    heightClass = "h-7",
    className = "",
    src = "/media/rivvr-wordmark.png",
}) {
    return (
        <img
            src={src}
            alt="RIVVR"
            draggable="false"
            className={`select-none ${className || `${heightClass} w-auto`}`}
        />
    );
}
